<template>
  <div>
    <el-form
      ref="form"
      size="mini"
      label-position="left"
      class="form-descriptions"
      :rules="rules"
      :model="formData"
    >
      <el-row :gutter="0">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_totalUnitInCtnQty') || '单箱产品数量'"
          >
            <el-input
              v-model="totalUnitInCtnQty"
              class="border-none"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_cartonType') || '纸箱类型'"
            prop="cartonType"
          >
            <dict-select
              v-model="formData.cartonType"
              :selectedLabel.sync="formData.v_cartonType"
              url="/master/common/dict/biz"
              :body="{ dictType: 'cartonType' }"
              :placeholder="
                $l('form_placeholder_cartonType') || '请选择纸箱类型'
              "
              clearable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_ctnInPalletQty') || '入托箱数'"
            prop="ctnInPalletQty"
          >
            <el-input-number
              v-model="formData.ctnInPalletQty"
              :placeholder="
                $l('form_placeholder_ctnInPalletQty') || '请输入入托箱数'
              "
              :min="0"
              :step="1"
              :precision="0"
              :controls="false"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <SkuTable
      ref="skuTable"
      class="mt-2"
      :platformCode="platformCode"
      @change="skuChange"
    />
  </div>
</template>

<script>
import SkuTable from './sku-table'
import validate from '@/libs/util.validate'
import { add } from '@/libs/util.number.js'
export default {
  components: { SkuTable },
  props: { platformCode: { type: String, default: '' } },
  data() {
    return {
      totalUnitInCtnQty: 0,
      formData: {},
      rules: {
        cartonType: [
          {
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (value) return callback()
              callback(' ')
            },
          },
        ],
        ctnInPalletQty: [
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (value) return callback()
              callback(' ')
            },
          },
        ],
      },
    }
  },
  methods: {
    skuChange(data) {
      this.totalUnitInCtnQty = 0

      if (!data?.length) return
      this.totalUnitInCtnQty = data
        .map((row) => row.unitInCtnQty)
        .reduce((r, n) => add(r, n), 0)
    },
    async validate() {
      const result = await validate.formValidate([this.$refs.form])
      const { cartonType, ctnInPalletQty } = this.formData
      if (!cartonType) {
        this.$message({
          message: this.$l('tips_error_cartonType_isnull') || '请选择纸箱类型',
          type: 'warning',
          showClose: true,
        })
        return false
      }

      if (!ctnInPalletQty) {
        if (0 != ctnInPalletQty) {
          this.$message({
            message:
              this.$l('tips_error_ctnInPalletQty_isnull') || '请输入入托箱数',
            type: 'warning',
            showClose: true,
          })
        } else {
          this.$message({
            message:
              this.$l('tips_error_ctnInPalletQty_is0') || '入托箱数不能为0',
            type: 'warning',
            showClose: true,
          })
        }
        return false
      }

      const skuResult = await this.$refs.skuTable.validate()
      return result && skuResult
    },
    getData() {
      const listSku = this.$refs.skuTable.getTableData()
      return {
        ...this.formData,
        totalUnitInCtnQty: this.totalUnitInCtnQty,
        listSku,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-form.form-descriptions {
    .el-form-item {
      margin-bottom: 0 !important;
      display: flex;
      flex-direction: row;
    }
    .el-form-item .el-form-item__label,
    .el-form-item .el-form-item__content {
      padding: 3px 5px;
      border: 1px solid #ebeef5;
    }
    .el-form-item .el-form-item__label {
      float: none;
      width: 110px;
      font-size: 12px !important;
      line-height: 26px;
      color: #909399;
      background-color: #fafafa;
      border-right-color: transparent;
    }
    .el-form-item .el-form-item__content {
      flex-grow: 1;
    }
    .el-col:not(:last-child) {
      .el-form-item .el-form-item__content {
        border-right-color: transparent;
      }
    }
    .el-input-number .el-input__inner {
      text-align: left;
    }
    .el-input.border-none .el-input__inner {
      border: none;
    }
  }
}
</style>
